import { styled } from "@material-ui/core";

export const CustomNewsletterField = styled("div")(({ theme }) => ({
  background: theme.palette.common.white,
  width: "100%",
  maxWidth: "380px",
  borderRadius: "38px",
  height: "48px",
  display: "flex",
  alingItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(0, "8px", 0, 2.75),
  "&.error": {
    border: `2px solid ${theme.palette.error.main}`
  },
  // Email input
  "& > .MuiInputBase-root": {
    flex: 1,
    height: "100%",
    padding: theme.spacing(1, 0),
    margin: 0,
    "& input": {
      padding: 0
    }
  },
  // Submit button
  "& > .MuiIconButton-root": {
    margin: theme.spacing("1px", 0),
    "& .MuiSvgIcon-root": {
      fontSize: "2.2rem"
    }
  },
  [theme.breakpoints.down("xs")]: {}
}));
